import { AppStateType } from './types';

function togglePreventExit(state: AppStateType, prevent_exit?: boolean) {
  state.prevent_exit = prevent_exit || !state.prevent_exit;
}

export default {
  togglePreventExit,
};
